<div class="search-status am-ctn am-ctn--xxl am-ctn--gtr">
  <ul class="mb-col-12">
    <li *ngFor="let item of items; trackBy: trackByItems">
      <mb-icon *ngIf="item.icon" [icon]="item.icon"></mb-icon><span>{{ item.text }}</span>
    </li>
  </ul>
</div>
